import React, { useState } from 'react';
import { STOCK_REFERENCE_DATE_HELP, STOCK_REFERENCE_DATE_STALE_WARNING, STOCK_STALE_DAYS } from "@outlets/configs/trendCopy";

const MS_PER_DAY = 24 * 60 * 60 * 1000;

const isStockReferenceStale = (referenceDate) => {
  if (!referenceDate) return false;
  return (Date.now() - new Date(referenceDate)) / MS_PER_DAY > STOCK_STALE_DAYS;
};

const UpdateValues = ({ stock, setStock, handleUpdateStock, updatedStock, calcStock }) => {
  const [toggle, setToggle] = useState(false);

  const handleInputChange = (value) => {
    let inputValue = value;

    inputValue = inputValue.replace(/[^\d,]/g, "");

    const commaCount = (inputValue.match(/,/g) || []).length;
    if (commaCount > 1) {
      const firstCommaIndex = inputValue.indexOf(",");
      inputValue =
        inputValue.slice(0, firstCommaIndex + 1) +
        inputValue.slice(firstCommaIndex + 1).replace(/,/g, "");
    }

    let [integerPart, decimalPart] = inputValue.split(",");

    if (integerPart) {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    if (decimalPart && decimalPart.length > 2) {
      integerPart = `${integerPart}${decimalPart.slice(0, 1)}`;
      decimalPart = decimalPart.slice(1, 3);
    }

    const formattedValue =
      decimalPart !== undefined
        ? `${integerPart},${decimalPart}`
        : integerPart;

    return formattedValue
  };

  return (
    <>
      <div className="margin-bottom-8 flex align-center">
        <button
          className={`accordion-toggle ${toggle ? "active" : ""}`}
          onClick={() => setToggle(!toggle)}
        />
        <span style={{ fontWeight: "bold", fontSize: '22px' }}>Estoque</span>
      </div>
      {toggle && <div className="update-extra-container">
        <span>Atualizar Valor de Estoque:</span>
        <div className="extra-value-container">
          <input
            placeholder="Valor"
            value={stock?.value}
            onChange={(e) => setStock({ ...stock, value: handleInputChange(e.target.value) })}
          />
          <input
            className="full"
            placeholder="Descrição"
            value={stock?.description}
            onChange={(e) => setStock({ ...stock, description: e.target.value })}
          />
          <button onClick={handleUpdateStock} className="button button-accent margin-bottom-8">Enviar</button>
        </div>
        <div className="flex align-center gap-8">
          <label htmlFor="stock-reference-date">Data de competência</label>
          <input
            id="stock-reference-date"
            type="date"
            value={stock?.reference_date ?? ""}
            onChange={(e) => setStock({ ...stock, reference_date: e.target.value })}
          />
        </div>
        <span className="text-small color-gray display-block margin-top-8">
          {STOCK_REFERENCE_DATE_HELP}
        </span>
        {isStockReferenceStale(stock?.reference_date) && (
          <span className="text-small color-red display-block margin-top-8">
            {STOCK_REFERENCE_DATE_STALE_WARNING}
          </span>
        )}
        <p className="auto-stock" onClick={calcStock}>Calcular valor automaticamente (Pago - Medido)?</p>
        {updatedStock !== "" && (
          updatedStock === 200 ? <span className="bold">Atualizado!</span> : <p>{updatedStock}</p>
        )}
      </div>}
    </>
  );
};

export default UpdateValues;